import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router';
import Navbar            from './components/Navbar.jsx';
import Footer            from './components/Footer.jsx';
import ScrollToTop       from './components/ScrollToTop.jsx';
import Home              from './pages/Home.jsx';
import About             from './pages/About.jsx';
//import Services         from './pages/Services.jsx';
import Terms             from './pages/Terms.jsx';
import Privacy           from './pages/Privacy.jsx';
import RefundPolicy      from './pages/RefundPolicy.jsx';
import DeactivateAccount from './pages/DeactivateAccount.jsx';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  );
}

function AppContent() {
  const { pathname } = useLocation();
  const hideLayout = pathname === '/terms-and-condition' || pathname === '/privacy-policy' || pathname === '/refund-policy-app' || pathname === '/about-app';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {!hideLayout && <Navbar />}
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/"                    element={<Home />}     />
          <Route path="/about"               element={<About />}    />
          <Route path="/about-app"           element={<About />}    />
          {/* <Route path="/services" element={<Services />} /> */}
          <Route path="/terms"               element={<Terms />}    />
          <Route path="/terms-and-condition" element={<Terms />}    />
          <Route path="/privacy"             element={<Privacy />}  />
          <Route path="/privacy-policy"      element={<Privacy />}  />
          <Route path="/refund-policy"       element={<RefundPolicy />} />
          <Route path="/refund-policy-app"   element={<RefundPolicy />} />
          <Route path="/account/request-deactivation" element={<DeactivateAccount />} />
        </Routes>
      </main>
      {!hideLayout && <Footer />}
    </div>
  );
}